// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const filling = "ProgressBar__filling__d1O8m";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const progressBar = "ProgressBar__progressBar__GqXA1";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";